import { TabPanel, TabPanels } from '@chakra-ui/react';
import React from 'react';
import EditOfficerAssementWrapper from '../EditOfficerAssessmentWrapper';
import OfficerAssessmentNotesShareWrapper from './OfficerAssessmentNotesShareWrapper';
const OfficerAssessmentModalShareTabPanels = ({ officerAssessment, }) => (React.createElement(TabPanels, { "data-testid": "officer_assessment_model_share_tab_panels" },
    React.createElement(TabPanel, null,
        React.createElement(EditOfficerAssementWrapper, { officerAssessment: officerAssessment, canEdit: false })),
    React.createElement(TabPanel, null,
        React.createElement(OfficerAssessmentNotesShareWrapper, { model: officerAssessment }))));
export default OfficerAssessmentModalShareTabPanels;
